<template>
    <div>
        <el-row>
            <el-col class="col-sm-12 col-md-8">
                <div style="    margin-top: 20px;">
                    <h4 class="room-type-title">{{roomType.name}}</h4>
                </div>
                <div>
                    <p class="pt-1 room-type-description" >{{roomType.description | shorten(140, '...') }}</p>
                </div>
                <div class="d-flex">
                    <div style="font-size: 2rem;">
                        <el-popover
                            placement="top"
                            title="Wi-Fi"
                            width="100"
                            trigger="hover"
                            content="Wi-Fi Included">

                            <b-icon slot="reference" style="border-radius: 5px" icon="wifi" class="border   p-2" variant=""></b-icon>

                        </el-popover>
                        <el-popover
                            placement="top"
                            title="Widescreen Tv"
                            width="200"
                            trigger="hover"
                            content="Widescreen Tv Included">

                            <b-icon slot="reference" style="border-radius: 5px" icon="tv" class="border   p-2" variant=""></b-icon>

                        </el-popover>
                        <el-popover
                            placement="top"
                            title="Private Balcony"
                            width="200"
                            trigger="hover"
                            content="Private Balcony Included">

                            <b-icon slot="reference" style="border-radius: 5px" icon="eye-slash-fill" class="border   p-2" variant=""></b-icon>

                        </el-popover>
                    </div>
                    <div class="col mt-2">
                        <v-select
                            placeholder="Select Theme"
                            label="name"
                            v-model="roomTheme"
                            :options="roomThemes"
                        />
                    </div>
                </div>
            </el-col>
            <el-col class="col-sm-12 col-md-4 pr-3 price-container">
                <div class="mt-4 text-center" v-if="loading">
                    <loading-component/>
                </div>
                <div v-else class="mt-4">
                    <div class="row">
                        <div class="col-4 col-sm-6 col-md-12 text-center">
                            <label class="mb-0 h5"><b class="float-right  price"><label v-if="numOfRoomNeeded >1">{{numOfRoomNeeded}} x </label> ${{ filteredRooms.totalPrice}}</b></label>
                            <br>
                            <b><label>Total Price</label></b>
                        </div>
                        <div class="col-4 col-sm-4 col-md-12 text-center">
                            <el-button id="book-now-btn" v-if="ableToBook && roomThemes.length != 0" @click="showBookPage()" style="background-color: #EF6E4A;width:150px !important">
                                <span style="color:#fff;">Book Now</span>
                            </el-button>
                            <el-button v-else type="danger" plain >
                                <span style="color:#000 ;">Room unavailable</span>
                            </el-button>
                        </div>
                    </div>

                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import DateWithPriceComponent from "../date_with_price/DateWithPriceComponent";
    import LoadingComponent from "../../common/LoadingComponent";
    export default {
        name: "RoomOfferComponent",
        components: {LoadingComponent, DateWithPriceComponent},
        props:[
            'roomType',
            'capacityOffer',
            'totalRooms',
            'searchFieldValue',
        ],
        data(){
            return {
                today: new Date().toLocaleDateString(),
                roomOffers: [],
                personalPage:false,
                filteredRooms:[],
                numOfRoomNeeded: 1,
                roomThemes: [],
                roomTheme:null,
                ableToBook:false,
                loading:false,
            }
        },
        methods: {
            getRoomOffer : function () {
                axios.get('/getAllRoomOffers')
                    .then(response => {
                        this.roomOffers = [...response.data];
                    })
                    .catch(error => {
                        console.log(error)
                    });
            },
            getFilteredRooms : function (values) {
                this.loading = true;
                axios.post('/getAllAvailableRooms',{
                    roomType:this.roomType.id,
                    checkinDate:values[0],
                    checkoutDate: values[1],
                    adult:values[2],
                    children:values[3],
                    infant:values[4],
                    numberOfDate:values[5],
                    room:values[6],
                }) .then(response => {
                    this.filteredRooms = response.data;
                    this.ableToBook = response.data.ableToBook;
                    // console.log(this.filteredRooms);
                    this.loading = false;
                }).catch(error => {
                    console.log('error when fetching room price');
                });
            },
            convertDate: function(inputFormat) {

                function pad(s) {
                    return (s < 10) ? '0' + s : s;
                }

                let d = new Date(inputFormat);
                return [  d.getFullYear(),pad(d.getMonth()+1),pad(d.getDate()),].join('-');

            },
            getDiffDate : function (start_date, end_date) {
                const date1 = new Date(start_date);
                const date2 = new Date(end_date);
                const diffTime = Math.abs(date2 - date1);
                return  Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            },
            getNameOfDate : function(date){

                let result = [];
                let day = '';
                let month = '';
                let date1 = new Date(date);

                day = date1.toString().split(' ')[0];
                month = date1.toString().split(' ')[1] + '-' +date1.getDate();
                result.push(day)
                result.push(month)

                return result;

            },
            getTomorrow : function() {
                const tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);
                let Tmonth = (tomorrow.getMonth() + 1);
                let Tday = tomorrow.getDate();
                if (Tmonth < 10)
                    Tmonth = "0" + Tmonth;
                if (Tday < 10)
                    Tday = "0" + Tday;
                let tomorrowsDate = tomorrow.getFullYear() + '-' + Tmonth + '-' + Tday;
                return tomorrowsDate;
            },
            setTodayAndTomorrow : function () {
                let date = new Date();
                let month = (date.getMonth() + 1);
                let day = date.getDate();
                if (month < 10)
                    month = "0" + month;
                if (day < 10)
                    day = "0" + day;
                let today = date.getFullYear() + '-' + month + '-' + day;
                $('#checkin').val(today);
                const tomorrow = new Date(date)
                tomorrow.setDate(tomorrow.getDate() + 1)
                let Tmonth = (tomorrow.getMonth() + 1);
                let Tday = tomorrow.getDate();
                if (Tmonth < 10)
                    Tmonth = "0" + Tmonth;
                if (Tday < 10)
                    Tday = "0" + Tday;
                let tomorrowsDate = tomorrow.getFullYear() + '-' + Tmonth + '-' + Tday;
                $('#checkout').val(tomorrowsDate);
            },
            showBookPage : function () {

                this.personalPage = true;
                this.$emit('data',  this.filteredRooms)
                this.$emit('roomOffer',  'roomOffer')
                // this.$emit('roomTheme',  $('#'+ this.filteredRooms.roomType.id).val())
                this.$emit('roomTheme', this.roomTheme ? this.roomTheme : this.roomThemes[0])
                this.$emit('secondProgress', true);

                // console.log($('#'+ this.filteredRooms.roomType.id).val())
                // console.log( this.filteredRooms)
            },
            setDataForModal :function (roomOffer,roomType) {
                this.$emit('dataForModal', [roomOffer,roomType])
            },
            getRoomTheme : function () {
                axios.post('/getRoomTheme',{
                    roomTypeId:this.roomType.id
                }).then(response => {
                    this.roomThemes = response.data
                    // console.log(this.roomThemes , 'theams')
                });
            }
        },
        created() {
            // console.log($('#roomTheme').val())
            let values = [
                this.convertDate(new Date().toLocaleDateString()),
                this.getTomorrow(),
                1,0, 0,7,1
            ];
            this.setTodayAndTomorrow();
            this.getRoomOffer();
            this.getFilteredRooms(values);
            this.getRoomTheme();

        },
        watch :{
            personalPage : function (newVal,oldVal) {
                this.$emit('personalPage', this.personalPage)
            },
            searchFieldValue :function (newVal,endVal) {
                let values = [
                    this.searchFieldValue.checkin,
                    this.searchFieldValue.checkout,
                    this.searchFieldValue.adult,
                    this.searchFieldValue.children,
                    this.searchFieldValue.infant,
                    this.getDiffDate(this.searchFieldValue.checkin,this.searchFieldValue.checkout),
                    this.searchFieldValue.numRoomNeeded
                ];

                this.numOfRoomNeeded = this.searchFieldValue.numRoomNeeded;
                this.getFilteredRooms(values);
            }
        }
    }
</script>

<style scoped>
    .room-type-title
    {
        font-weight: bold;
        font-size: x-large;
    }

    @media screen and (max-width: 768px) {
        .room-type-title , .room-type-description, .icons{
            text-align: center;
        }
    }
    @media (min-width: 768px) {
        .price-container{
            border-left: solid lightgrey 1px;
            height: 200px !important;
        }
    }
    #book-now-btn:hover{
        border-radius: 25px !important;
        background-color: #0a3544 !important;
        transition:0.6s;
    }

</style>
